import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'category-page-shimmer',
  templateUrl: './category-page-shimmer.component.html',
  styleUrls: ['./category-page-shimmer.component.scss'],
  imports: [CommonModule]
})
export class CategoryPageShimmerComponent {


  readonly layoutType = input<string>('');

  items: any = new Array(4);
  productShimmerListItem: any = new Array(5);
}

